import { BrazeCustomEvent } from 'constants/braze';
import useTracking from 'hooks/useTracking';
import useGoogleTagManagerTrack from 'hooks/useGoogleTagManagerTrack';
import { userRegisterFailEvent, userRegisterSuccessEvent, authenticateSuccessEvent } from 'libs/common/event-tracker/events';
import { GoogleTagManagerEvent } from 'constants/google';
import { brazeLogCustomEvent } from 'libs/common/braze/logCustomEvent';
const gtmTypeByAuthType = {
  apple: 'apple',
  facebook: 'facebook',
  google: 'google',
  internal: 'email'
};
export const useRegistrationTracking = () => {
  const {
    track
  } = useTracking();
  const {
    googleTagManagerTrack
  } = useGoogleTagManagerTrack();
  return _ref => {
    let {
      response,
      authType,
      email
    } = _ref;
    const gtmAuthType = gtmTypeByAuthType[authType];

    if ('errors' in response) {
      track(userRegisterFailEvent({
        type: authType,
        errors: response.errors
      }));
      return;
    }

    googleTagManagerTrack(GoogleTagManagerEvent.Register, {
      auth_type: gtmAuthType,
      user_email: email
    });
    track(userRegisterSuccessEvent({
      type: authType,
      userId: response.user.id
    }));
    track(authenticateSuccessEvent({
      type: authType,
      userId: response.user.id
    }));
    const {
      external_id
    } = response.user;

    if (external_id) {
      brazeLogCustomEvent({
        event: BrazeCustomEvent.RegistrationCompleted,
        userExternalId: external_id
      }, {
        forceCache: true
      });
    }
  };
};